var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('top-menu'),_c('div',{staticClass:"page-content"},[_c('left-menu'),_c('div',{staticClass:"content-wrapper"},[_c('header-content'),_c('div',{staticClass:"content"},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }